<template>
<span>
<p><span style="font-size:10pt">Inhalt der Leistung:</span></p>
  <ul>
    <li>
      <p><span style="font-size:10pt">Dokumentation &uuml;ber:</span></p>

      <ul>
        <li>
          <p><span style="font-size:10pt">Welche &Uuml;berspannungsschutzableiter werden ben&ouml;tigt</span></p>
        </li>
        <li>
          <p><span style="font-size:10pt">Wo werden die &Uuml;berspannungsschutzableiter eingesetzt</span></p>
        </li>
        <li>
          <p><span style="font-size:10pt">Wie werden die &Uuml;berspannungsschutzableiter montiert</span></p>
        </li>
      </ul>
    </li>
    <li>
      <p><span style="font-size:10pt">St&uuml;ckliste / Produktliste (LV)</span></p>
    </li>
    <li>
      <p><span style="font-size:10pt">Weitreichende &Uuml;berspannungsschutzma&szlig;nahmen</span></p>
    </li>
  </ul>

  <p><span style="font-size:9pt"><em>Optional: Nach der Fertigstellung des Konzeptes k&ouml;nnen wir Ihnen gerne das Konzept pers&ouml;nlich vorstellen<br />
(Planungsabschlussgespr&auml;ch)</em></span></p>
</span>
</template>

<script>
export default {
  name: "TooltipUeberspannungsschutzkonzept"
}
</script>

<style scoped>

</style>
